import React, { lazy, Suspense } from 'react';

import CardListSkeleton from '@monorepo/common/components/CardListSkeleton';

const OrdersList = lazy(() => import('./OrdersList'));

export default (props: Config) => (
  <Suspense fallback={<CardListSkeleton />}>
    <OrdersList {...props} />
  </Suspense>
);
